import axios from 'axios'
const http = axios.create({
  // withCredentials: true,
  baseURL: process.env.baseUrl + '/csgo',
})

export default {
  /**
   * 查询赛事列表
   * params type  0 邀请赛 1 公开赛
   * params status  0 未发布 1 已发布 2 已审核 即将开始 3 进行中 4 结束
   * params pageNo
   * params pageSize 8
   **/
  async getEvents(options) {
    let res
    if (options.status) {
      res = await http.get(
        `/event/getEvents?status=${options.status}&pageNo=${options.pageNo}&pageSize=${options.pageSize}`
      )
    } else {
      res = await http.get(
        `/event/getEvents?pageNo=${options.pageNo}&pageSize=${options.pageSize}`
      )
    }
    return res.data
  },

  /**
   * 最近比赛比分
   **/
  async getLastScore() {
    const { data } = await http.get(`/event/getLastScore`)
    return data
  },

  /**
   * 赛事信息
   * params eventId
   **/
  async getSingleEvent(eventId) {
    const { data } = await http({
      url: `/event/getSingleEvent?eventId=${eventId}`,
      method: 'get',
      withCredentials: true,
    })
    return data
  },

  /**
   * 赛事动态
   * params eventId
   **/
  async getNotice(eventId) {
    const { data } = await http.get(`/event/getNotice?eventId=${eventId}`)
    return data
  },

  /**
   * 奖金分配
   * params eventId
   **/
  async getAllocation(eventId) {
    const { data } = await http.get(`/event/getAllocation?eventId=${eventId}`)
    return data
  },

  /**
   * 获取赛制
   * params eventId
   **/
  async getSystem(eventId) {
    const { data } = await http.get(`/event/getSystem?eventId=${eventId}`)
    return data
  },

  /**
   * 获取报名表
   * params eventId
   **/
  async getApplyForm() {
    const { data } = await http({
      url: `/event/getApplyForm`,
      method: 'get',
      withCredentials: true,
    })
    return data
  },

  /**
   * 报名赛事
   * params regionIds
   * params teamMemberInfos   List<TeamMemberInfoDTO>
   * params eventId
   * params type   0 报名 1 修改
   **/
  async joinEvent(eventId, type = 0) {
    const { data } = await http({
      url: `/event/joinEvent?eventId=${eventId}&type=${type}`,
      method: 'post',
      withCredentials: true,
    })
    return data
  },

  /**
   * 参赛队伍
   * params eventId
   * params pageNo
   * params pageSize  15
   **/
  async getTeamInfos(options) {
    const { data } = await http.get(
      `/event/getTeamInfos?eventId=${options.eventId}&pageNo=${options.pageNo}&pageSize=${options.pageSize}`
    )
    return data
  },

  /**
   * 参赛阵容
   * params eventId
   **/
  async getJoinTeamMemberInfo(eventId) {
    const { data } = await http({
      url: `/event/getJoinTeamMemberInfo?eventId=${eventId}`,
      method: 'get',
      withCredentials: true,
    })
    return data
  },

  /**
   * 取消报名
   * params eventId
   **/
  async deleteJoin(eventId) {
    const { data } = await http({
      url: `/event/deleteJoin?eventId=${eventId}`,
      method: 'get',
      withCredentials: true,
    })
    return data
  },

  /**
   * 查看赛程
   * params eventId
   * params type    0 总决赛  1 淘汰赛  2 小组赛
   * params win   0 败者组  1 胜者组   默认1
   * params group    eg:'A'
   **/
  async getEventPlan(opt) {
    const { data } = await http.get(`/eventSchedule/getEventPlan`, { params: opt })
    return data
  },

  /**
   * 排行数据
   * params eventId
   * params type   1 决赛 2 小组赛
   * params data    String
   **/
  async getDataRank(options) {
    let res
    if (options.type) {
      res = await http.get(
        `/event/getDataRank?eventId=${options.eventId}&type=${options.type}&data=${options.data}`
      )
    } else {
      res = await http.get(
        `/event/getDataRank?eventId=${options.eventId}&data=${options.data}`
      )
    }
    return res.data
  },

  /**
   * 查看小组
   * @param {number} eventId
   */
  async getGroup(eventId) {
    const { data } = await http.get(`/event/getGroup?eventId=${eventId}`)
    return data
  },

  /**
   * 赛事直播
   * params eventId
   **/
  async getMedia(eventId) {
    const { data } = await http.get(`/event/getMedia?eventId=${eventId}`)
    return data
  },

  /**
   * 首页banner图
   * params eventId
   * params type   1 决赛 2 小组赛
   * params data    String
   **/
  async getBanner() {
    const { data } = await http.get(`/event/getBanner`)
    return data
  },

  /**
   * 友情赞助
   * params eventId
   **/
  async getSponsors(eventId) {
    const { data } = await http.get(`/event/getSponsors?eventId=${eventId}`)
    return data
  },
}
